// extracted by mini-css-extract-plugin
export default {"modal":"archiveCaseModal_modal__ROrdr","archiveModal":"archiveCaseModal_archiveModal__es1a9","rowCenter":"archiveCaseModal_rowCenter__CW233","row":"archiveCaseModal_row__6+EBN"};